import HelperNumber from "../helpers/HelperNumber";
import i18n from "../resources/i18n";
import { regex } from "../utils/regex";

function required(message: string = i18n.t('Campo obrigatório')) {
    return {
        type: 'required',
        msg: message
    }
}

function maxLength(value: number, message: string) {
    return {
        type: "maxLength",
        params: [value],
        msg: message
    }
}

function minLength(value: number, message: string) {
    return {
        type: "minLength",
        params: [value],
        msg: message
    }
}

function min(value: number, message: string) {
    return {
        type: "min",
        params: [value],
        msg: message
    }
}

function cpfOrCnpj(message: string, document: string) {
    const onlyNumbers = HelperNumber.justNumber(document) ?? '';
    const lengthinfo = (onlyNumbers?.length??0);
    if(lengthinfo <= 11){
        cpf(message);
    }else{
        cnpj(message);
    }
}

function cpf(message: string) {
    return {
        type: "pattern",
        params: [regex.cpfRegex],
        msg: message
    }
}

function cnpj(message: string) {
    return {
        type: "pattern",
        params: ['\\d{2}\\.\\d{3}\\.\\d{3}/\\d{4}\\-\\d{2}'],
        msg: message
    }
}

function cpfCnpj(message: string) {
    return {
        type: "pattern",
        params: [/(?:(?:\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})|(?:\d{3}\.?\d{3}\.?\d{3}-?\d{2}))/],
        msg: message
    }
}

function email(message: string = i18n.t('E-mail inválido')) {
    return {
        type: "email",
        msg: message
    }
}

const CustomValidator = {
    email,
    required,
    maxLength,
    minLength,
    cpf,
    cnpj,
    cpfCnpj,
    min,
    cpfOrCnpj
}

export default CustomValidator;
